import { createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from 'redux/store';
import { MyAccount, MyAccountTabs, OWNER_DETAILS } from 'types/myAccount';
import { SEND_MONEY, SendAndRequest, SendRequestTabs } from 'types/sendAndRequest';
import { ACTIVE_STAFF, Staff, StaffTabs } from 'types/staff';
import { defaultOffSet, defaultPageSize } from 'appConfig';
import { TableState } from 'types/common';

export type TabComponents = 'staff' | 'myAccount' | 'sendAndRequest';
interface SetCurrentTabPayload {
    component: TabComponents;
    currentTab: SendRequestTabs | MyAccountTabs | StaffTabs;
}

interface AppState {
    sendAndRequest: SendAndRequest;
    myAccount: MyAccount;
    staff: Staff;
    table: TableState;
}
const tableInitialState = {
    pageNumber: 0,
    pageSize: defaultPageSize,
    offset: defaultOffSet,
};
const initialState: AppState = {
    sendAndRequest: {
        currentTab: SEND_MONEY,
    },
    myAccount: {
        currentTab: OWNER_DETAILS,
    },
    staff: {
        currentTab: ACTIVE_STAFF,
    },
    table: tableInitialState,
};
export const setStaffTab = (currentTab: StaffTabs) => (dispatch: AppDispatch) => {
    dispatch(
        setCurrentTab({
            component: 'staff',
            currentTab,
        })
    );
};
export const setMyAccountTab = (currentTab: MyAccountTabs) => (dispatch: AppDispatch) => {
    dispatch(
        setCurrentTab({
            component: 'myAccount',
            currentTab,
        })
    );
};
export const setSendAndRequestTab = (currentTab: SendRequestTabs) => (dispatch: AppDispatch) => {
    dispatch(
        setCurrentTab({
            component: 'sendAndRequest',
            currentTab,
        })
    );
};

const appSlice = createSlice({
    name: 'appSlice',
    initialState,
    reducers: {
        setCurrentTab: (state, action: { payload: SetCurrentTabPayload }) => {
            const { payload } = action || {};
            if (!payload) return;
            const { component, currentTab } = payload;
            if (!component || !currentTab) return;
            state[component].currentTab = currentTab;
        },
        updateTableState: (state, action: { payload: TableState }) => {
            const { payload } = action;
            if (!payload) return;
            state.table = { ...state.table, ...payload };
        },
        resetTableState: (state) => {
            state.table = tableInitialState;
        },
    },
});

export const { setCurrentTab, updateTableState, resetTableState } = appSlice.actions;

export default appSlice.reducer;
